import React, { Fragment, FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { localize } from "src/l10n";

interface IProps {
    notification: Spintr.INotification;
}

const GroupTodoAssignedNotification: FunctionComponent<IProps> = (props) => {
    const notification = props.notification as Spintr.IGroupTodoAssignedNotification;
    if (!notification) {
        return null;
    }

    return (
        <Fragment>
            {
                localize("DuHarBlivitAnsvarigForAttGoraPunkten") + " "
            }
            <Link to={notification.url}>
                {notification.todoTitle}
            </Link>
        </Fragment>
    );
};

export default GroupTodoAssignedNotification;